import { apply, call as sagaCall, put, delay as sagaDelay } from 'redux-saga/effects';
import { addError } from '@ers/pages/toasts/toasts.actions';
import { isError } from '../api/ResponseProcessors';

export { all, put, takeLatest, takeEvery, select, fork, throttle, take, delay, apply, takeLeading } from 'redux-saga/effects';

const { SentryLogger: Logger } = require('@ers/errors/');

export function* call(...args) {
    try {
        return yield sagaCall(...args);
    } catch (error) {
        yield put(addError('Wystąpił błąd. Odśwież stronę i spróbuj ponownie.', 5));
        Logger.error(error);
        return null;
    }
}

export function* delayedPut(seconds, ...args) {
    yield sagaDelay(seconds * 1000);
    yield put(...args);
}

export function* fetch(...args) {
    const result = {
        data: null,
        error: null
    };
    const [client, method] = args;
    const methodArgs = args[2] || [];
    const response = yield apply(client, method, methodArgs);
    if (isError(response)) {
        result.error = response;
    } else {
        result.data = response;
    }
    return result;
}